import React from "react";
import { deriveWorkflowSteps } from "./documentUtils";

// Wave 3 — workflow visualization: a horizontal stepper derived from the
// receipt state (Sent → Delivered → Opened → Actioned). Presentation only —
// the step position is derived, never invented: a document that has not been
// delivered still shows Sent as its furthest completed step.
const WorkflowTimeline = ({ receiptState, isArchived = false }) => {
  const steps = deriveWorkflowSteps(receiptState, isArchived);
  return (
    <section className="file-card__workflow" aria-label="Workflow progress">
      <ol className="file-card__workflow-track" aria-label="Workflow progress">
        {steps.map(({ label, state }) => (
          <li
            key={label}
            className={`file-card__workflow-step file-card__workflow-step--${state}`}
            aria-current={state === "current" ? "step" : undefined}
          >
            <span className="file-card__workflow-dot" aria-hidden="true" />
            <span className="file-card__workflow-label">{label}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default WorkflowTimeline;
